import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

function CustomErrorTemplate(props) {
  var errors = props.errors;

  return React.createElement(
    "div",
    null,
    errors.map(function (error, i) {
      return React.createElement(
        "div",
        { key: i, className: "error-detail" },
        React.createElement(
          Typography,
          { variant: "caption" },
          error
        )
      );
    })
  );
}

CustomErrorTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  errors: PropTypes.array
} : {};

CustomErrorTemplate.defaultProps = {
  errors: []
};

export default CustomErrorTemplate;